import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Contact Us | ShipSkis',
  description:
    'We make ski travel easy, and that includes support. Our friendly customer ' +
    'service team is just a text, call, or email away, every day of the week.',
  alternates: {
    canonical: 'https://www.shipskis.com/contact',
  },
}

export default metadata
